// Auth imports
import { getAuth } from 'firebase/auth'
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

// firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyAKKrX-GcBdf-qf5Ecrk5Qwin0hvPIcyIA',
  authDomain: 'peace-of-mind-ba2e9.firebaseapp.com',
  projectId: 'peace-of-mind-ba2e9',
  storageBucket: 'peace-of-mind-ba2e9.appspot.com',
  messagingSenderId: '167203285976',
  appId: '1:167203285976:web:983b5cf54a2a6ff7dc60ad'
}

// Create app and auth
const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const db = getFirestore(app)
export { auth, db }
